import { render, staticRenderFns } from "./StockWarningReport.vue?vue&type=template&id=46b18c96&scoped=true"
import script from "./StockWarningReport.vue?vue&type=script&lang=js"
export * from "./StockWarningReport.vue?vue&type=script&lang=js"
import style0 from "./StockWarningReport.vue?vue&type=style&index=0&id=46b18c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b18c96",
  null
  
)

export default component.exports